export default function ErrorText({ text }: { text: string }) {
	return <div className="mt-1 verify-text">{text}</div>;
}
